module.exports = __webpack_public_path__ + "img/dental4.47839b72.jpeg";